// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-div {
  width: 150px;
  padding: 10px;
  align-items: center;
  justify-content: center;
  margin: 4% auto;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.big-text-div {
  font-family: Merriweather Sans;
  font-weight: 600;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.small-text-div {
  font-family: Merriweather Sans;
  font-weight: 500;
  font-size: 13px;
}
.link-button {
  position: relative;
  display: inline-block;
  padding: 10px 20px;
  color: #a25035;
  font-size: 16px;
  text-decoration: none;
  text-transform: uppercase;
  overflow: hidden;
  transition: 0.5s;
  margin-top: 20px;
  letter-spacing: 4px;
}

.link-button:hover {
  background: #a25035;
  color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #a25035, 0 0 25px #a25035, 0 0 50px #a25035,
    0 0 100px #a25035;
}

.link-button span {
  position: absolute;
  display: block;
}

.link-button span:nth-child(1) {
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #a25035);
  animation: btn-anim1 1s linear infinite;
}

@keyframes btn-anim1 {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 100%;
  }
}

.link-button span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #a25035);
  animation: btn-anim2 1s linear infinite;
  animation-delay: 0.25s;
}

@keyframes btn-anim2 {
  0% {
    top: -100%;
  }
  50%,
  100% {
    top: 100%;
  }
}

.link-button span:nth-child(3) {
  bottom: 0;
  right: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, transparent, #a25035);
  animation: btn-anim3 1s linear infinite;
  animation-delay: 0.5s;
}

@keyframes btn-anim3 {
  0% {
    right: -100%;
  }
  50%,
  100% {
    right: 100%;
  }
}

.link-button span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #a25035);
  animation: btn-anim4 1s linear infinite;
  animation-delay: 0.75s;
}

@keyframes btn-anim4 {
  0% {
    bottom: -100%;
  }
  50%,
  100% {
    bottom: 100%;
  }
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

h1 {
  font-size: 5.25vmin;
  text-align: center;
  color: #fff;
}
p {
  font-size: max(10pt, 2.5vmin);
  line-height: 1.4;
  color: #0e390e;
  margin-bottom: 1.5rem;
}

.wrap {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 120vmin;
  height: 80vh;
  margin: 8vh auto;
  transition: 0.1s ease-in-out;
  position: relative;
  overflow: hidden;
}
.overlay {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  background: grey;
  transition: 0.2s ease-in-out;
  z-index: 1;
}
.overlay-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 15vmin;
  height: 100%;
  padding: 0.5rem 0 0 0.5rem;
  border: 3px solid;
  border-image: linear-gradient(
      to bottom,
      #aea724 5%,
      forestgreen 35% 65%,
      #aea724 95%
    )
    0 0 0 100%;
  transition: 0.7s ease-in-out 0.2s;
  z-index: 1;
}
.image-content {
  position: absolute;
  top: 0;
  right: 0;
  width: 60vmin;
  height: 90%;
  background-size: cover;
  transition: 0.7s ease-in-out;
}

.dots {
  position: absolute;
  bottom: 1rem;
  right: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 55px;
  height: 4vmin;
  transition: 0.7s ease-in-out 0.7s;
}
.dot {
  width: 14px;
  height: 14px;
  background: yellow;
  border: 1px solid indigo;
  border-radius: 50%;
  transition: 0.7s ease-in-out 0.7s;
}

.text {
  position: absolute;
  top: 0;
  right: 0;
  width: 90vmin;
  height: 100%;
  padding: 3vmin 4vmin;
  background: #fff;
  box-shadow: inset 1px 1px 15px 0 rgba(0 0 0 / 0.4);
}

.shift .overlay {
  transform: translateX(-90vmin);
}
.shift .image-content {
  width: 30vmin;
}
.shift .overlay-content {
  border: none;
  transition-delay: 0.2s;
  transform: translateX(90vmin);
}

/* Animations and timing delays */
.animate {
  animation-duration: 0.7s;
  animation-timing-function: cubic-bezier(0.26, 0.53, 0.74, 1.48);
  animation-fill-mode: backwards;
}
/* Pop In */
.pop {
  animation-name: pop;
}
@keyframes pop {
  0% {
    opacity: 0;
    transform: scale(0.5, 0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1, 1);
  }
}

/* Slide Left */
.slide-left {
  animation-name: slide-left;
}
@keyframes slide-left {
  0% {
    opacity: 0;
    transform: translate(-40px, 0);
  }
  100% {
    opacity: 1;
    transform: translate(0, 0);
  }
}

.slide-up {
  animation-name: slide-up;
}
@keyframes slide-up {
  0% {
    opacity: 0;
    transform: translateY(3em);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.delay-1 {
  animation-delay: 0.7s;
}
.delay-2 {
  animation-delay: 0.6s;
}
.delay-3 {
  animation-delay: 0.9s;
}
.delay-4 {
  animation-delay: 1.2s;
}
.delay-5 {
  animation-delay: 1.2s;
}
.delay-6 {
  animation-delay: 1.8s;
}
.delay-7 {
  animation-delay: 2.1s;
}
.delay-8 {
  animation-delay: 2.4s;
}

ol li {
  padding: 5px;
}

.checkbox-style {
  margin-left: 2%;
}

.outercard-quizInstruction {
  width: 60%;
  margin: auto;
  margin-top: 4%;
  height: 85%;
  margin-bottom: 5%;
  font-family: Merriweather Sans;
}

.title-quizInstruction {
  justify-content: center;
  align-items: center;
  display: flex;
  font-weight: 700;
  margin: 2%;
}

.inner-div1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  height: 96%;
}
.inner-div2 {
  display: inline-block;
  width: 98%;
  height: 96%;
  border-radius: 20px 0px 0px 20px;
  text-align: center;
  vertical-align: middle;
  padding-top: 10%;
}
.inner-div3 {
  display: flex;
}
.noquiz {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70%;
  font-weight: bold;
}
.completed-msg{
  font-size: 20px;
   color: green
}
.noattempts{
  font-size: 20px;
  color: #A25035
}
.card-body{
  overflow-y: auto;
}
 
`, "",{"version":3,"sources":["webpack://./src/components/modules/learners/LearnersContent.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB;qBACmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,WAAW;EACX,WAAW;EACX,wDAAwD;EACxD,uCAAuC;AACzC;;AAEA;EACE;IACE,WAAW;EACb;EACA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,yDAAyD;EACzD,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;;IAEE,SAAS;EACX;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX,WAAW;EACX,yDAAyD;EACzD,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;EACd;EACA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,OAAO;EACP,UAAU;EACV,YAAY;EACZ,yDAAyD;EACzD,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;EACA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB;;;;;;cAMY;EACZ,iCAAiC;EACjC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,iCAAiC;AACjC;EACE,wBAAwB;EACxB,+DAA+D;EAC/D,8BAA8B;AAChC;AACA,WAAW;AACX;EACE,mBAAmB;AACrB;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,sBAAsB;EACxB;AACF;;AAEA,eAAe;AACf;EACE,0BAA0B;AAC5B;AACA;EACE;IACE,UAAU;IACV,8BAA8B;EAChC;EACA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,eAAe;GACd;AACH;AACA;EACE,eAAe;EACf;AACF;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".col-div {\n  width: 150px;\n  padding: 10px;\n  align-items: center;\n  justify-content: center;\n  margin: 4% auto;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.big-text-div {\n  font-family: Merriweather Sans;\n  font-weight: 600;\n  font-size: 16px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.small-text-div {\n  font-family: Merriweather Sans;\n  font-weight: 500;\n  font-size: 13px;\n}\n.link-button {\n  position: relative;\n  display: inline-block;\n  padding: 10px 20px;\n  color: #a25035;\n  font-size: 16px;\n  text-decoration: none;\n  text-transform: uppercase;\n  overflow: hidden;\n  transition: 0.5s;\n  margin-top: 20px;\n  letter-spacing: 4px;\n}\n\n.link-button:hover {\n  background: #a25035;\n  color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 0 5px #a25035, 0 0 25px #a25035, 0 0 50px #a25035,\n    0 0 100px #a25035;\n}\n\n.link-button span {\n  position: absolute;\n  display: block;\n}\n\n.link-button span:nth-child(1) {\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(90deg, transparent, #a25035);\n  animation: btn-anim1 1s linear infinite;\n}\n\n@keyframes btn-anim1 {\n  0% {\n    left: -100%;\n  }\n  50%,\n  100% {\n    left: 100%;\n  }\n}\n\n.link-button span:nth-child(2) {\n  top: -100%;\n  right: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(180deg, transparent, #a25035);\n  animation: btn-anim2 1s linear infinite;\n  animation-delay: 0.25s;\n}\n\n@keyframes btn-anim2 {\n  0% {\n    top: -100%;\n  }\n  50%,\n  100% {\n    top: 100%;\n  }\n}\n\n.link-button span:nth-child(3) {\n  bottom: 0;\n  right: -100%;\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(270deg, transparent, #a25035);\n  animation: btn-anim3 1s linear infinite;\n  animation-delay: 0.5s;\n}\n\n@keyframes btn-anim3 {\n  0% {\n    right: -100%;\n  }\n  50%,\n  100% {\n    right: 100%;\n  }\n}\n\n.link-button span:nth-child(4) {\n  bottom: -100%;\n  left: 0;\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(360deg, transparent, #a25035);\n  animation: btn-anim4 1s linear infinite;\n  animation-delay: 0.75s;\n}\n\n@keyframes btn-anim4 {\n  0% {\n    bottom: -100%;\n  }\n  50%,\n  100% {\n    bottom: 100%;\n  }\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nh1 {\n  font-size: 5.25vmin;\n  text-align: center;\n  color: #fff;\n}\np {\n  font-size: max(10pt, 2.5vmin);\n  line-height: 1.4;\n  color: #0e390e;\n  margin-bottom: 1.5rem;\n}\n\n.wrap {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  width: 120vmin;\n  height: 80vh;\n  margin: 8vh auto;\n  transition: 0.1s ease-in-out;\n  position: relative;\n  overflow: hidden;\n}\n.overlay {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding: 1rem 0.75rem;\n  background: grey;\n  transition: 0.2s ease-in-out;\n  z-index: 1;\n}\n.overlay-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 15vmin;\n  height: 100%;\n  padding: 0.5rem 0 0 0.5rem;\n  border: 3px solid;\n  border-image: linear-gradient(\n      to bottom,\n      #aea724 5%,\n      forestgreen 35% 65%,\n      #aea724 95%\n    )\n    0 0 0 100%;\n  transition: 0.7s ease-in-out 0.2s;\n  z-index: 1;\n}\n.image-content {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 60vmin;\n  height: 90%;\n  background-size: cover;\n  transition: 0.7s ease-in-out;\n}\n\n.dots {\n  position: absolute;\n  bottom: 1rem;\n  right: 2rem;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  width: 55px;\n  height: 4vmin;\n  transition: 0.7s ease-in-out 0.7s;\n}\n.dot {\n  width: 14px;\n  height: 14px;\n  background: yellow;\n  border: 1px solid indigo;\n  border-radius: 50%;\n  transition: 0.7s ease-in-out 0.7s;\n}\n\n.text {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 90vmin;\n  height: 100%;\n  padding: 3vmin 4vmin;\n  background: #fff;\n  box-shadow: inset 1px 1px 15px 0 rgba(0 0 0 / 0.4);\n}\n\n.shift .overlay {\n  transform: translateX(-90vmin);\n}\n.shift .image-content {\n  width: 30vmin;\n}\n.shift .overlay-content {\n  border: none;\n  transition-delay: 0.2s;\n  transform: translateX(90vmin);\n}\n\n/* Animations and timing delays */\n.animate {\n  animation-duration: 0.7s;\n  animation-timing-function: cubic-bezier(0.26, 0.53, 0.74, 1.48);\n  animation-fill-mode: backwards;\n}\n/* Pop In */\n.pop {\n  animation-name: pop;\n}\n@keyframes pop {\n  0% {\n    opacity: 0;\n    transform: scale(0.5, 0.5);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1, 1);\n  }\n}\n\n/* Slide Left */\n.slide-left {\n  animation-name: slide-left;\n}\n@keyframes slide-left {\n  0% {\n    opacity: 0;\n    transform: translate(-40px, 0);\n  }\n  100% {\n    opacity: 1;\n    transform: translate(0, 0);\n  }\n}\n\n.slide-up {\n  animation-name: slide-up;\n}\n@keyframes slide-up {\n  0% {\n    opacity: 0;\n    transform: translateY(3em);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.delay-1 {\n  animation-delay: 0.7s;\n}\n.delay-2 {\n  animation-delay: 0.6s;\n}\n.delay-3 {\n  animation-delay: 0.9s;\n}\n.delay-4 {\n  animation-delay: 1.2s;\n}\n.delay-5 {\n  animation-delay: 1.2s;\n}\n.delay-6 {\n  animation-delay: 1.8s;\n}\n.delay-7 {\n  animation-delay: 2.1s;\n}\n.delay-8 {\n  animation-delay: 2.4s;\n}\n\nol li {\n  padding: 5px;\n}\n\n.checkbox-style {\n  margin-left: 2%;\n}\n\n.outercard-quizInstruction {\n  width: 60%;\n  margin: auto;\n  margin-top: 4%;\n  height: 85%;\n  margin-bottom: 5%;\n  font-family: Merriweather Sans;\n}\n\n.title-quizInstruction {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  font-weight: 700;\n  margin: 2%;\n}\n\n.inner-div1 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: auto;\n  height: 96%;\n}\n.inner-div2 {\n  display: inline-block;\n  width: 98%;\n  height: 96%;\n  border-radius: 20px 0px 0px 20px;\n  text-align: center;\n  vertical-align: middle;\n  padding-top: 10%;\n}\n.inner-div3 {\n  display: flex;\n}\n.noquiz {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 70%;\n  font-weight: bold;\n}\n.completed-msg{\n  font-size: 20px;\n   color: green\n}\n.noattempts{\n  font-size: 20px;\n  color: #A25035\n}\n.card-body{\n  overflow-y: auto;\n}\n \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
